import React from 'react';
import {
  SiPython,
  SiReact,
  SiFastapi,
  SiFlask,
  SiDocker,
  SiJavascript,
  SiMysql,
  SiGit,
  SiLinux,
  SiTensorflow,
  SiPytorch,
  SiOpencv,
  SiArduino,
  SiPostgresql,
  SiCplusplus,
  SiEspressif,
  SiNvidia
} from 'react-icons/si';
import LogoLoop from './LogoLoop';
import './TechLogos.css';

const techLogos = [
  { node: <SiPython />, title: 'Python' },
  { node: <SiReact />, title: 'React' },
  { node: <SiFastapi />, title: 'FastAPI' },
  { node: <SiFlask />, title: 'Flask' },
  { node: <SiDocker />, title: 'Docker' },
  { node: <SiJavascript />, title: 'JavaScript' },
  { node: <SiMysql />, title: 'MySQL' },
  { node: <SiGit />, title: 'Git' },
  { node: <SiLinux />, title: 'Linux' },
  { node: <SiTensorflow />, title: 'TensorFlow' },
  { node: <SiPytorch />, title: 'PyTorch' },
  { node: <SiOpencv />, title: 'OpenCV' },
  { node: <SiArduino />, title: 'Arduino' },
  { node: <SiPostgresql />, title: 'PostgreSQL' },
  { node: <SiCplusplus />, title: 'C++' },
  { node: <SiEspressif />, title: 'Espressif' },
  { node: <SiNvidia />, title: 'NVIDIA' }
];

const TechLogos = () => {
  return (
    <section className="tech-logos-section">
      <div className="tech-logos-loop">
        <LogoLoop
          logos={techLogos}
          speed={60}
          direction="left"
          logoHeight={40}
          gap={56}
          hoverSpeed={15}
          fadeOut
          fadeOutColor="var(--bg-primary)"
          scaleOnHover
          ariaLabel="Technologies I work with"
        />
      </div>
    </section>
  );
};

export default TechLogos;
